export const activeList = [
    "Feedback of last 3-5 Buylead consumed",
    "Available Relevant Buy Leads",
    "Importance of being active on Lead Manager",
    "Improving Client Engagement using LMS call back feature",
    "Products performance in A&D rank MCATs",
    "Importance of Ratings and Reviews",
    "Importance of consumption of minimum 2 Buyleads daily",
    "Local Competitors and Importance of presence on IM"
]

export const inactiveList = [
    "Available Relevant Buy Leads",
    "Importance of Daily Buy Lead Consumption",
    "Loss of Business Due to Missing PNS Calls",
    "Adding More Numbers to Improve Call Pickup Rate",
    "Importance of Being Active on Lead Manager",
    "Importance of Online Presence",
	"Products performance in B rank MCATs"
]